import React from 'react';

import Autocomplete from 'components/Autocomplete/Autocomplete';
import { Button, FormControl, InputLabel, MenuItem, Select as MuiSelect } from '@mui/material';
import { tt } from '@i18n/tt';

import useStyles from '../../styles';
import { useTicketsFilters } from './useTicketsFilters';

const TicketsFilters: React.FC<{ className?: string, resetTrigger?: boolean }> = ({ className, resetTrigger }) => {
  const classes = useStyles();

  const {
    activeIndex,
    useCustomTicketStatusFilter,
    customFilterTicketStatuses,
    ticketFilters,
    onSelectFilter,
    onSaveCustomFilterTicketStatuses,
    onStatusesChange,
  } = useTicketsFilters(resetTrigger);

  return (
    <div className={className}>
      <div>
        <div className={classes.filtersList}>
          {!useCustomTicketStatusFilter ? (
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel id="ticket-filter-select-label">{tt('pages.tickets.ticketStatuses')}</InputLabel>
              <MuiSelect
                labelId="ticket-filter-select-label"
                id="ticket-filter-select"
                value={activeIndex}
                label={tt('pages.tickets.ticketStatuses')}
                onChange={(e) => {
                  const value = typeof e.target.value === 'string' ? parseInt(e.target.value) : e.target.value;
                  onSelectFilter(value);
                }}
              >
                {ticketFilters.map((filter, index) => (
                  <MenuItem key={index} value={index}>
                    {tt(filter.name as 'pages.tickets.tabs.all')}{filter.quantity ? ` (${filter.quantity})` : ''}
                  </MenuItem>
                ))}
              </MuiSelect>
            </FormControl>
          ) : (
            <div>
              <Autocomplete
                options={customFilterTicketStatuses}
                onChange={onStatusesChange}
                size="small"
                placeholder={tt('pages.tickets.select')}
              />
              <div className={classes.saveButton}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onSaveCustomFilterTicketStatuses}
                >
                  {tt('pages.tickets.filterButton')}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketsFilters;
